import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledTableCell } from './TableCell.styles';

/**
 * A native [`<td>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/td) element.
 *
 * @since 8.0.0
 */
export var TableCell = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledTableCell, _extends({
    ref: forwardedRef
  }, props));
});
TableCell.displayName = 'Table.Cell';